import axios from "axios";

export const state = {
    visits: [],
};

export const getters = {
    visits: state => state.visits,
};

export const mutations = {
    setVisits(state, newValue) {
        state.visits = newValue
    },
};

export const actions = {
    fetchVisits({ commit }) {
        axios.get('/visits').then(res => {
            commit('setVisits', res.data.visits);
        })
    },
    filterVisits({commit}, {schoolterm}) { 
        let formData = new FormData();
        formData.append("schoolterm", schoolterm);
        //formData.append("year", year);
        let url = "/filtervisits";
        axios.post(url, formData).then((response) => {
            commit('setVisits', response.data.visits)
        })
    },
};